//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import adminSection from '~/mixins/admin-section'
import VImg from '~/components/global/v/img.vue'

export default {
  name: 'AdminSectionImageWithText',
  components: { VImg },
  mixins: [adminSection]
}
